import { Array, Number, Record, Static } from "runtypes";

export const SeasonsOrderRequestRuntype = Record({
  schoolId: Number,
  seasons: Array(
    Record({
      id: Number,
      order: Number,
      // I will fill the schoolId part with what I was sent
    })
  ),
});

export interface ISeasonsOrderRequest
  extends Static<typeof SeasonsOrderRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/api/types/ISeasonsOrderRequest.ts